import { useUserContext } from '../../../contexts/UserContext';
import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { Btn } from '../../ui';

export const PaymentMethodCard = () => {
    const { company } = useUserContext();
    const { isCoreActive } = useSubscriptionContext();

    const companyData = company as Record<string, unknown> | null;
    const paymentMethod = companyData?.paymentMethod as string | null;

    // For now, payment method is a simple string. When Stripe is integrated,
    // this will show card brand, last 4, and expiry.
    const hasPaymentMethod = !!paymentMethod;

    return (
        <div className="payment-method-card">
            <div className="payment-method-header">
                <h4 className="payment-method-title">Payment Method</h4>
                {hasPaymentMethod && (
                    <button className="payment-method-update-link">Update card</button>
                )}
            </div>

            {hasPaymentMethod ? (
                <div className="payment-method-info">
                    <div className="payment-method-card-display">
                        <span className="payment-method-brand">VISA</span>
                        <span className="payment-method-number">•••• •••• •••• 4242</span>
                    </div>
                    <span className="payment-method-expiry">Expires 09/2028 · Default</span>
                    {isCoreActive && (
                        <span className="payment-method-next-charge">
                            Next charge on billing date
                        </span>
                    )}
                </div>
            ) : (
                <div className="payment-method-empty">
                    <div className="payment-method-empty-icon">💳</div>
                    <p>No payment method on file</p>
                    <Btn
                        variant="primary"
                        buttonSize="sm"
                        buttonText="+ Add Payment Method"
                        buttonOnClick={() => {/* TODO: open payment modal */ }}
                    />
                </div>
            )}
        </div>
    );
};
